import { useLocation, useNavigate } from 'react-router-dom'

import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'

import ConversationsListContainer from './components/conversations-list'
import ChatPanelContainer from './components/chat-panel'
import IconButton from '@/components/ui/icon-button'

import useConversationsStore from '@/stores/useConversationsStore'
import { useAwsCredentialsManager } from './context/AWS-credentials.context'

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.background.default,
    overflow: 'hidden',
  },
  'left-panel': {
    width: '300px',
    flexShrink: 0,
    borderRight: `1px solid ${theme.palette.grey[400]}`,
    display: 'flex',
    flexDirection: 'column',
  },
  'right-panel': {
    flexGrow: 1,
    display: 'flex',
    minWidth: 0,
    flexDirection: 'column',
    overflowY: 'auto',
  },
  floatingButtons: {
    position: 'absolute',
    padding: theme.spacing(1),
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    zIndex: 2000,
  },
}))

const PlusChatContainer = () => {
  const classes = useStyles()
  const { isAuthorized } = useAwsCredentialsManager()

  const isSidebarCollapsedStore = useConversationsStore((state) => state.isSidebarCollapsed)
  const toggleSidebar = useConversationsStore((state) => state.toggleSidebar)

  const isSidebarCollapsed = !isAuthorized ? true : isSidebarCollapsedStore

  const navigate = useNavigate()
  const location = useLocation()

  const handleAddClick = () => {
    const basePath = location.pathname.split('/plus')[0]
    navigate(basePath + '/plus')
  }

  return (
    <div className={clsx(classes.root, 'pag-app-content')}>
      <div
        className={classes['left-panel']}
        style={{ width: isSidebarCollapsed ? '0px' : '300px', transition: 'width 0.3s ease' }}
      >
        <ConversationsListContainer />
      </div>
      <div className={classes['right-panel']}>
        {isSidebarCollapsed && (
          <div className={classes.floatingButtons}>
            <IconButton icon="menu" onClick={toggleSidebar} />
            <IconButton icon="add" onClick={handleAddClick} />
          </div>
        )}
        <ChatPanelContainer />
      </div>
    </div>
  )
}

export default PlusChatContainer
